import classNames from 'classnames';
import {useProductOptions} from '@shopify/hydrogen';
import {isProductOptionSingleVariant} from '../../utils/product';

const SelectIcon = () => {
  return (
    <svg
      className={classNames(
        'absolute',
        'h-5',
        'fill-gray-400',
        'right-2.5',
        'pointer-events-none',
      )}
      viewBox="0 0 20 20"
      focusable="false"
    >
      <path d="m10 16-4-4h8l-4 4zm0-12 4 4H6l4-4z"></path>
    </svg>
  );
};

/**
 * A client component that tracks a selected variant and/or selling plan state, as well as callbacks for modifying the state
 */
export default function ProductOptions() {
  const {options, setSelectedOption, selectedOptions} = useProductOptions();

  return (
    <>
      {!isProductOptionSingleVariant(options) &&
        options?.map((option) => {
          if (!option?.name || !option?.values) {
            return null;
          }
          const {name, values} = option;
          const selectedItem = selectedOptions && selectedOptions[name];
          return (
            <fieldset key={name} className="mt-2">
              <legend className={classNames('mb-1', 'text-sm', 'font-light')}>
                {name}
              </legend>
              <div
                className={classNames(
                  'relative',
                  'flex',
                  'flex-wrap',
                  'items-center',
                  'gap-4',
                )}
              >
                <select
                  name={name}
                  id={name}
                  value={selectedItem}
                  className={classNames(
                    'flex',
                    'flex-1',
                    'appearance-none',
                    'rounded',
                    'border',
                    'bg-select',
                    'bg-small',
                    'bg-right',
                    'bg-no-repeat',
                    'px-3',
                    'py-2',
                  )}
                  onChange={(event) => {
                    setSelectedOption &&
                      setSelectedOption(name, event.target.value);
                  }}
                >
                  {values.map((value) => {
                    const id = `option-${name}-${value}`;

                    return (
                      <option className="sr-only" key={id} value={value}>
                        {value}
                      </option>
                    );
                  })}
                </select>
                <SelectIcon />
              </div>
            </fieldset>
          );
        })}
    </>
  );
}
